import React from 'react'
import BaseButton from '@material-ui/core/Button'
import PropTypes from 'prop-types'

const propTypes = {
  /** Use the naming standards. */
  id: PropTypes.string.isRequired,
  /** The content of the button. */
  children: PropTypes.node.isRequired,
  /** The variant to use */
  variant: PropTypes.oneOf(['text', 'contained', 'outlined']),
  /** The color of the component. It supports those theme colors that make sense for this component. */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),
  /** If true, the button will be disabled. */
  disabled: PropTypes.bool
}

const defaultProps = {
  variant: 'text',
  color: 'default',
  disabled: false
}

/**
 * The `Button` component wrap https://material-ui.com/components/buttons/.
 *
 * Only important or basic options has been added in propTypes.
 * You can still use the other features of material-ui if supported by the current version of our design system.
 *
 * Using or adding new options that is not on the propTypes please notify the Front-End Architect
 */

const Button = props => {
  const { children, ...rest } = props
  return (
    <BaseButton data-cid='Button-root' {...rest}>
      {children}
    </BaseButton>
  )
}

Button.propTypes = propTypes
Button.defaultProps = defaultProps

export default Button
